import { PORTAL_BORDER, PORTAL_CHAT, PORTAL_NAV } from '../arkorbit-ui/portalTheme';

/** Portal-Shell — Cursor-inspiriert: schmal, dezent, eine Border-Linie. */

export const PORTAL_SHELL = {
  app: 'flex h-screen bg-[#07070a] text-[#e6e7ea] overflow-hidden',
  /** Einzelne dezente Trennlinie statt Regenbogen-Stripe */
  topBorder: 'h-px w-full bg-white/[0.06] flex-shrink-0',
  mobileBar:
    'md:hidden flex items-center justify-between px-3 py-3 bg-slate-950/95 border-b border-white/[0.06] flex-shrink-0 backdrop-blur-sm',
  sidebar:
    'w-[240px] bg-[#0d0f12] border-r border-white/[0.06] flex flex-col h-full min-h-0 flex-shrink-0',
  sidebarCollapsed: 'w-[52px]',
  sidebarHeaderBorder: 'border-b border-white/[0.06]',
  sidebarNavItem: PORTAL_NAV.item,
  sidebarNavActive: PORTAL_NAV.active,
  sidebarNavIdle: PORTAL_NAV.idle,
  mainArea: 'relative flex-1 flex flex-col min-w-0 overflow-hidden',
  mainScroll: 'flex-1 overflow-y-auto custom-scrollbar',
  mainContent: 'relative p-4 md:p-6 lg:p-8',
  settingsOverlay: 'fixed inset-0 bg-black/50 z-[60] backdrop-blur-[2px]',
  settingsPanel:
    'fixed inset-y-0 right-0 z-[70] w-full max-w-md bg-[#07070a] border-l border-violet-400/30 shadow-2xl flex flex-col portal-slide-in-right',
  commandPaletteOverlay:
    'fixed inset-0 z-[80] bg-black/50 backdrop-blur-[2px] flex items-start justify-center pt-[12vh] px-4',
  commandPalettePanel:
    'w-full max-w-lg rounded-xl border border-white/[0.08] bg-slate-950 shadow-2xl overflow-hidden',
  input:
    'w-full bg-slate-900/80 border border-white/[0.08] rounded-xl text-white text-sm focus:outline-none focus:ring-1 focus:ring-blue-500/40 placeholder:text-slate-600',
  ingestBar: 'rounded-xl border border-white/[0.06] bg-slate-900/40 overflow-hidden',
  splitPane:
    'flex min-h-0 flex-1 basis-0 flex-col overflow-hidden rounded-xl border border-white/[0.06] bg-slate-900/20 lg:flex-row lg:items-stretch lg:min-h-[min(56vh,560px)]',
  paneHeader:
    'flex items-center gap-1.5 px-2.5 py-1 border-b border-white/[0.06] bg-slate-900/60 text-[11px] flex-shrink-0 min-h-[28px] max-h-[32px]',
  arkoChromeBar:
    'flex flex-wrap items-center gap-1 min-h-[28px] flex-shrink-0 border-b border-white/[0.06] px-1 py-0.5',
  arkoCollapsedStrip:
    'hidden lg:flex w-10 flex-shrink-0 flex-col items-center border-l border-white/[0.06] bg-slate-900/40 py-2 gap-2',
  ooCanvas: 'bg-slate-950',
  ooCanvasOverlay: 'bg-slate-950/80',
  chatFrame: `${PORTAL_CHAT.shell} overflow-hidden`,
  textMuted: 'text-slate-500',
  textSubtle: 'text-slate-400',
} as const;
